"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VumFlattenedConverter = void 0;
const CommissionIdConverter_1 = require("./CommissionIdConverter");
const types_1 = require("../shared/types");
const VumService_1 = require("./VumService");
class VumFlattenedConverter {
    static convertUserVehicleRelationToFlattenedVehicle(relation) {
        var _a, _b, _c, _d, _e, _f;
        return Object.assign(Object.assign({ vin: (_a = relation.vehicle) === null || _a === void 0 ? void 0 : _a.vin }, CommissionIdConverter_1.CommissionIdConverter.convertCommissionIdToData((_b = relation.vehicle) === null || _b === void 0 ? void 0 : _b.commissionId)), { nickname: relation.vehicleNickname, licensePlateNumber: relation.licensePlate, primaryCar: !!relation.primaryCar, dealerId: relation.dealerId, dealerBrandCode: relation.dealerBrandCode, allocatedDealerCountry: relation.allocatedDealerCountry, preferredContact: relation.preferredContact, role: (_c = types_1.Role[relation.role]) !== null && _c !== void 0 ? _c : types_1.Role.UNKNOWN, enrollmentStatus: (_d = types_1.EnrollmentStatus[relation.enrollmentStatus]) !== null && _d !== void 0 ? _d : types_1.EnrollmentStatus.UNKNOWN, devicePlatform: (_f = types_1.DevicePlatform[(_e = relation.vehicle) === null || _e === void 0 ? void 0 : _e.modBackend]) !== null && _f !== void 0 ? _f : types_1.DevicePlatform.UNKNOWN });
    }
    static convertUserVehicleRelationsToFlattenedVehicles(relations) {
        const vehicles = [];
        relations.forEach((relation) => {
            vehicles.push(this.convertUserVehicleRelationToFlattenedVehicle(relation));
        });
        return vehicles;
    }
    static convertFlattenedVehicleToUserVehicleRelation(vehicle) {
        const commissionId = CommissionIdConverter_1.CommissionIdConverter.convertCommissionDataToId(vehicle.commissionNumber, vehicle.bid, vehicle.commissionNumberYear);
        return {
            vehicleNickname: vehicle.nickname,
            licensePlate: vehicle.licensePlateNumber,
            vehicle: {
                vin: vehicle.vin,
                commissionId,
            },
        };
    }
    static convertVehicleRelationsToFlattenedUsers(relations) {
        const users = [];
        relations.forEach((relation) => {
            users.push(this.convertVehicleRelationToFlattenedUser(relation));
        });
        return users;
    }
    static convertVehicleRelationToFlattenedUser(relation) {
        var _a, _b, _c, _d, _e;
        return {
            primaryCar: !!relation.primaryCar,
            role: (_a = types_1.Role[relation.role]) !== null && _a !== void 0 ? _a : types_1.Role.UNKNOWN,
            roleStatus: (_b = VumService_1.VumUserRoleStatus[relation.roleStatus]) !== null && _b !== void 0 ? _b : VumService_1.VumUserRoleStatus.UNKNOWN,
            enrollmentStatus: (_c = types_1.EnrollmentStatus[relation.enrollmentStatus]) !== null && _c !== void 0 ? _c : types_1.EnrollmentStatus.UNKNOWN,
            userId: (_e = (_d = relation.user) === null || _d === void 0 ? void 0 : _d.idKitUserId) !== null && _e !== void 0 ? _e : '',
        };
    }
}
exports.VumFlattenedConverter = VumFlattenedConverter;
//# sourceMappingURL=VumFlattenedConverter.js.map